import type { RouteMonitoring } from '../models';
import { computeDeliveryCountsFromPercentages } from '../utils/computeDeliveryCountsFromPercentages';

export interface RouteCardMetrics {
  deliveredPercentage: number;
  totalDelivered: number;
  totalFailed: number;
  totalPending: number;
  totalExpired: number;
}

function useRouteCardMetrics(
  routeDetail: RouteMonitoring | undefined
): RouteCardMetrics {
  const deliveredPercentage = routeDetail?.metrics.deliveredPercentage ?? 0;

  if (!routeDetail) {
    return {
      deliveredPercentage,
      totalDelivered: 0,
      totalFailed: 0,
      totalPending: 0,
      totalExpired: 0,
    };
  }

  const { delivered, failed, pending, expired } = computeDeliveryCountsFromPercentages(
    routeDetail.metrics.totalStops,
    routeDetail.metrics.deliveredPercentage ?? 0,
    routeDetail.metrics.failedPercentage ?? 0,
    routeDetail.metrics.pendingPercentage ?? 0,
    routeDetail.metrics.expiredPercentage
  );

  return {
    deliveredPercentage,
    totalDelivered: delivered,
    totalFailed: failed,
    totalPending: pending,
    totalExpired: expired,
  };
}

export default useRouteCardMetrics;
